<script>
  import { Modal } from "sveltestrap";

  export let toggle;
  export let isOpen;
</script>

<style>
  .modal-width {
    max-width: 500px;
  }
</style>

<Modal {isOpen} {toggle}>
  <div id="instant-booking-info-modal">
    <div class="card shadow border-0 h-100 text-center modal-width">
      <div class="m-3">
        <img
          class="w-25"
          src="/static/images/directory-logo-crop-420.png"
          alt="The Guide logo" />
        <h3 class="mt-3">Why Book Direct?</h3>
        <br />
        <p class="font-weight-normal text-base">
          When you book through an online travel agent, businesses pay $15-20 in
          commission for every $100 of your booking.
          <br />
          <br />
          Booking direct lets business owners spend that money on improving the guest experience.
          This keeps the money in the local economy – helping to create more tourism jobs in
          countries where this is crucial to the economy.
          <br />
          <br />
          We encourage you to travel responsibly by booking direct.
        </p>
        <p type="button" on:click={toggle} class="text-muted font-weight-normal">Close</p>
      </div>
    </div>
  </div>
</Modal>
